module.exports = __webpack_public_path__ + "media/Quest_Game_UI_Bass_Tap_Button_Click_1_Snap.75d3a65e.wav";